module.exports = __webpack_public_path__ + "img/text1.4281cddd.png";